import { reduce } from '@atlaskit/adf-utils/traverse';
import { type ADFEntity } from '@atlaskit/adf-utils/types';

import { type ADFDocument } from '@canvas/adf-types';

export const getAdfTextContent = (adf: ADFEntity, joinDelimeter?: string): string => {
  return reduce<string[]>(
    adf,
    (result, node) => {
      if (node.text) {
        result.push(node.text);
      } else if (node.type === 'emoji') {
        result.push(node.attrs?.text);
      } else if (node.type === 'hardBreak') {
        result.push('\n');
      }
      return result;
    },
    []
  ).join(joinDelimeter !== undefined ? joinDelimeter : ' ');
};

export const getAdfTextContentWithUrl = (
  adf: ADFDocument,
  joinDelimeter?: string
): string => {
  return reduce<string[]>(
    adf,
    (result, node) => {
      if (node.text) {
        result.push(node.text);
      } else if (node.type === 'emoji') {
        result.push(node.attrs?.text);
      } else if (node.type === 'hardBreak') {
        result.push('\n');
      } else if (node.type === 'inlineCard' && node.attrs?.url) {
        result.push(node.attrs?.url);
      }
      return result;
    },
    []
  ).join(joinDelimeter !== undefined ? joinDelimeter : ' ');
};
